import React from 'react';
import styled from 'styled-components';

const Span=styled.span`
font-size:20;
padding:10px;
`;
export default class PlayerItem extends React.Component {
    

    componentWillMount() {

    }

    componentDidMount() {
      
    }

    componentWillReceiveProps(nextProps) {
       
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        
        //console.info('PlayerItem - render called.', this.props);
        let player = this.props.data;
        let result = player.currentresult == 0 ? "E": player.currentresult;
        return (<div className="playeritem" ><Span>Name:{player.name}</Span><Span>Result: {result}</Span></div>);
        
    }
}





// WEBPACK FOOTER //
// ./src/Components/PlayerItem/PlayerItem.js